import type { MarketType } from '@ps/isp-web-services-types';

export const getIsMatchOddsNinetyMarket = (
  marketType: MarketType | undefined
): marketType is 'MATCH_ODDS_90' => marketType === 'MATCH_ODDS_90';
